<template>
    <div class="settlementRule-wrap">
        <el-tooltip v-if="settlementRuleObj[staticPath].tipHtml" placement="top">
            <div slot="content" v-html="settlementRuleObj[staticPath].tipHtml"></div>
            <div class="index_times index_times_sph">
                {{ settlementRuleObj[staticPath].text }}
            </div>
        </el-tooltip>
        <div v-else class="index_times">
            {{ settlementRuleObj[staticPath].text }}
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            settlementRuleObj: {
                '/': {
                    tipHtml: `视频/音频课-普通课程，履约后7天；<br/>
                        视频/音频课-互联网营销课程，履约后14天；<br/>
                        非音视频课程，履约后7天`,
                    text: '结算规则？'
                },
                '/dd/': {
                    tipHtml: `抖店结算规则：<br/>
                    订单确认收货的10天后。`,
                    text: '结算规则？'
                },
                '/ks/': {
                    tipHtml: ``,
                    text: '(结算周期t+8)'
                },
                '/wx/': {
                    tipHtml: ``,
                    text: '(结算周期t+8)'
                },
                '/sph/': {
                    tipHtml: `视频号小店结算规则：<br/>
                        1、系统自动完成发货，用户可以点击“确认收货”；发货起10天后，系统将自动确认收货。若10天后发货物流单状态未显示已签收，系统将延迟5天判断自动确认收货，延迟次数最大为3次，即累计延迟确认收货天数上限为15天。<br/>
                        2、商品确认收货7天内（含7天）为售后期，若售后期内未产生退款、退换货等售后纠纷行为，售后期结束后待结算资金将解冻转入可提现资金，解冻转入可提现资金所需时间约为1~2天。<br/>
                        3、若售后期内发生仅退款、退货退款等售后或交易纠纷的行为，则待结算资金需在售后、交易纠纷维权完结7天后解冻转入可提现资金，解冻转入可提现资金所需时间约为1~2天。`,
                    text: '结算规则？'
                },
                '/xhs/': {
                    tipHtml: `小红书结算规则：<br/>
                        订单货款会在消费者确认收货+7天后结算，期间若发生售后则需等待售后完结再结算；结算完成后资金将进入订单对应的结算账户中。`,
                    text: '结算规则？'
                },
            }
        }
    }
}
</script>

<style lang="less" scoped>
.settlementRule-wrap{
    margin: 0 !important;
}
.index_times{
    margin-left: 10px;
    color: red;
    font-size: 12px;
    &.index_times_sph{
        margin-left: 12px;
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        .icon{
            margin: 0 0px 0 3px;
            width: 16px;
            height: 16px;
        }
    }
}
</style>
